import React from 'react';

import { Icon } from '../Icon';
import { IconType } from '../../components/Icon';

export const semanticIcons: { [key: string]: IconType } = {
    error: 'x-1',
    warning: 'info-1',
    caution: 'info-1',
    success: 'tick-1',
};

export default semanticIcons;

export interface Props {
    children: React.ReactNode;
}

const baseStatusMessage = (displayNameRoot: string) => {
    const type = displayNameRoot.toLowerCase();
    const BaseStatusMessage: React.FC<Props> = ({ children }) => (
        <div className={`status-message--${type}`}>
            <Icon type={semanticIcons[type]} variations={['offset-right']} />
            <div>{children}</div>
        </div>
    );
    BaseStatusMessage.displayName = `${displayNameRoot}StatusMessage`;
    return BaseStatusMessage;
};

export const SuccessStatusMessage = baseStatusMessage('Success');
export const WarningStatusMessage = baseStatusMessage('Warning');
export const ErrorStatusMessage = baseStatusMessage('Error');
